<generic-container textAlign="left" bold="last" titleKey="">
    <app-ecom-product-table></app-ecom-product-table>
</generic-container>
